"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RFPSkuExtraQuery = exports.RFPSkuExtraUpdate = exports.RFPSkuExtraCreate = exports.RFPSkuExtraTransport = void 0;
const typebox_1 = require("@sinclair/typebox");
const common_1 = require("../common");
const meta_data_1 = require("../common/meta-data");
const ServiceLineItemType_1 = require("./ServiceLineItemType");
exports.RFPSkuExtraTransport = typebox_1.Type.Object({
    id: typebox_1.Type.String({ format: 'uuid' }),
    rfpSkuID: typebox_1.Type.String({ format: 'uuid' }),
    quantity: typebox_1.Type.Number(),
    serviceLineItemType: typebox_1.Type.Pick(ServiceLineItemType_1.ServiceLineItemType, [
        'id',
        'displayName',
        'description',
        'rfpHelperText',
        'rfpAlwaysGetPrice',
    ]),
    /**
     * Make sure it's in cents. amount is only for hauler responses or the winning bid on rfp
     */
    unitPrice: typebox_1.Type.Optional(typebox_1.Type.Integer()),
    totalPrice: typebox_1.Type.Optional(typebox_1.Type.Integer()),
    billingFrequency: typebox_1.Type.Optional(common_1.Duration),
    serviceFrequency: typebox_1.Type.Optional(common_1.Duration),
    serviceCycleLength: typebox_1.Type.Optional(typebox_1.Type.Integer()),
    noteToVendor: typebox_1.Type.Optional(typebox_1.Type.String()),
    noteFromVendor: typebox_1.Type.Optional(typebox_1.Type.String()),
    requiredInRfp: typebox_1.Type.Boolean(),
    metadata: meta_data_1.MetaData,
});
exports.RFPSkuExtraCreate = typebox_1.Type.Intersect([
    typebox_1.Type.Omit(exports.RFPSkuExtraTransport, ['id', 'metadata', 'totalPrice', 'rfpSkuID', 'serviceLineItemType']),
    typebox_1.Type.Object({
        serviceLineItemTypeID: typebox_1.Type.String({ format: 'uuid' }),
    }),
]);
exports.RFPSkuExtraUpdate = typebox_1.Type.Partial(typebox_1.Type.Intersect([typebox_1.Type.Omit(exports.RFPSkuExtraTransport, ['metadata', 'totalPrice', 'rfpSkuID', 'serviceLineItemType'])]));
exports.RFPSkuExtraQuery = typebox_1.Type.Partial(typebox_1.Type.Object({
    limit: typebox_1.Type.Integer(),
    offset: typebox_1.Type.Integer(),
    orderBy: typebox_1.Type.Optional(typebox_1.Type.Union([typebox_1.Type.Literal('createdAt'), typebox_1.Type.Literal('lastUpdatedAt')])),
    reverseSort: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
    rfpSkuID: typebox_1.Type.String({ format: 'uuid' }),
    createdBefore: typebox_1.Type.String({ format: 'date-time' }),
    createdAfter: typebox_1.Type.String({ format: 'date-time' }),
}));
//# sourceMappingURL=rfp-sku-extra.js.map